import React, { useId } from 'react'
import { SwipeableDrawer, Typography } from '@mui/material'
import { useStyles } from './style'

/*
 * The house bottom sheet: a drawer from the bottom edge with rounded top
 * corners, a drag handle and safe-area padding. Menus and pickers that are a
 * popover on desktop render through this on phones — the toolbar account menu,
 * the filter bar. Swipe down, tap the backdrop or press Escape to close.
 *
 * `title` is an optional subtle heading that also names the sheet for
 * assistive tech. Sheets that draw their own header (the filter bar) leave it
 * out, and can name the sheet after it with `labelledBy`, that heading's id.
 * Anything else goes to the drawer (`ModalProps`, `SlideProps`, …).
 */
const noop = () => {}

const ActionSheet = ({ open, onClose, title, labelledBy, children, dataTest, ...rest }) => {
  const classes = useStyles()
  const titleId = useId()
  const labelId = title ? titleId : labelledBy

  return (
    <SwipeableDrawer
      anchor='bottom'
      open={open}
      onClose={onClose}
      onOpen={noop}
      disableSwipeToOpen
      PaperProps={{
        className: classes.paper,
        role: 'dialog',
        'aria-modal': true,
        ...(labelId ? { 'aria-labelledby': labelId } : {})
      }}
      data-test={dataTest}
      {...rest}
    >
      <div className={classes.handle} />
      {title && (
        <Typography id={titleId} component='h2' variant='body2' className={classes.title}>
          {title}
        </Typography>
      )}
      {children}
    </SwipeableDrawer>
  )
}

export default ActionSheet
